import { doc, updateDoc } from "firebase/firestore";
import { GetIDToken, auth, db } from "../../firebase/FirebaseConfig";
import { GAEvent, GALogEvent } from "../../firebase/GoogleAnalytics";
import { ExtractServerResponse } from "../Shared";
import { ProjectStreamCallbacks, StreamProjectResponse, projectMessageFromData } from "./ProjectStream";
import { AssistantCreativityLevel, ProjectMessage } from "./types";

export async function SendProjectMessage(projectID: string, content: string, creativityLevel: AssistantCreativityLevel, signal?: AbortSignal): Promise<ProjectMessage> {
  const currentUser = auth.currentUser;
  if (!currentUser) throw new Error("User not logged in");

  GALogEvent(GAEvent.Project.sentMessage);

  const idToken = await GetIDToken();
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/projects/${projectID}/messages`, {
    method: "POST",
    body: JSON.stringify({ content, creativityLevel }),
    headers: {
      authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
    signal,
  });

  const { message } = (await ExtractServerResponse(response)).data as { message: ProjectMessage };
  return projectMessageFromData(message);
}

export async function StreamProjectMessage(projectID: string, content: string, creativityLevel: AssistantCreativityLevel, callbacks: ProjectStreamCallbacks, signal: AbortSignal): Promise<void> {
  const currentUser = auth.currentUser;
  if (!currentUser) throw new Error("User not logged in");

  GALogEvent(GAEvent.Project.sentMessage);
  return StreamProjectResponse(`${process.env.REACT_APP_SERVER_URL}/projects/${projectID}/messages/stream`, { content, creativityLevel }, callbacks, signal);
}

export async function FetchProjectMessages(projectID: string, signal?: AbortSignal): Promise<ProjectMessage[]> {
  const currentUser = auth.currentUser;
  if (!currentUser) return [];

  const idToken = await GetIDToken();
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/projects/${projectID}/messages`, {
    method: "GET",
    headers: {
      authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
    signal,
  });

  const { messages } = (await ExtractServerResponse(response)).data as { messages: ProjectMessage[] };

  const projectDocRef = doc(db, `users/${currentUser.uid}/projects/${projectID}`);
  await updateDoc(projectDocRef, { lastActiveDate: new Date() });

  return messages.map(projectMessageFromData).reverse();
}
